const BaseError = require('make-error').BaseError;

class MismatchError extends BaseError {
    constructor(errorMessage='Item values have changed. Reload the item and try again.') {
        super(errorMessage);
    }
}

module.exports = MismatchError;